import React, { Component } from 'react';
import './style.css';
import { Trans, translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import NoImage from './no-image.png';

class Comparison extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value, next: undefined });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    const { t } = this.props;
    const name1 = this.props.pair.projectObjects[0].name;
    const name2 = this.props.pair.projectObjects[1].name;
    const image1 = this.props.pair.projectObjects[0].image;
    const image2 = this.props.pair.projectObjects[1].image;

    let skip = () => {
      const nextPath = this.props.skip(this.props.pair);
      if (this.props.history.canGo(1)) {
        this.props.history.goForward();
      } else {
        this.props.history.push(nextPath);
      }
    };

    return (
      <div className="card-body">
        <div className="object-images">
          <div className="object-div">
            <img
              src={image1 || NoImage}
              alt={name1}
              className="object-cmp-image"
            />
            <strong className="object-name text-center">{name1}</strong>
          </div>
          <div className="object-div">
            <img
              src={image2 || NoImage}
              alt={name2}
              className="object-cmp-image"
            />
            <strong className="object-name text-center">{name2}</strong>
          </div>
        </div>
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="question">
          <Trans i18nKey="comparisonNewDescription">
            When you compare <b>"{{ name1 }}"</b> and <b>"{{ name2 }}"</b>, are
            they more similar or different for you?
          </Trans>
        </div>
        <div className="comparison-buttons">
          <button
            onClick={() => this.setState({ next: 'similar' })}
            className={
              'btn btn-large btn-outline-primary btn-comparison' +
              (this.state.next === 'similar' ? ' active' : '')
            }
          >
            {t('Similar')}
          </button>
          <button
            onClick={() => this.setState({ next: 'different' })}
            className={
              'btn btn-large btn-outline-primary btn-comparison' +
              (this.state.next === 'different' ? ' active' : '')
            }
          >
            {t('Different')}
          </button>
        </div>
        <div className="actions">
          <button className="btn btn-link" onClick={skip}>
            Skip Question
          </button>
          <Link to={this.props.url + '/story/' + this.state.next}>
            <button
              className="btn btn-primary btn-round btn-next"
              disabled={this.state.next === undefined}
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default translate('translations')(withRouter(Comparison));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Pair/comparison.js